import { cn } from "@/utils/cn";

interface PencomBannerProps {
  type: "info" | "warning" | "error" | "success";
  title?: string;
  titleComponent?: React.ReactNode;
  description?: string;
  onClose?: () => void;
  // visibility?: boolean;
  action?: React.ReactNode;
  className?: string;
  icon?: string;
}

export const PencomBanner = ({
  type,
  className,
  title,
  titleComponent,
  action,
  onClose,
  icon,
}: PencomBannerProps) => {
  const bannerStyles = {
    info: {
      backgroundColor: "var(--color-lightest-cream)",
      color: "var(--color-medium-dark-grey)",
    },
    success: {
      backgroundColor: "var(--color-lightest-green)",
      color: "var(--color-primary-button)",
    },
    warning: {
      backgroundColor: "var(--color-lightest-cream)",
      color: "var(--color-dark-brown)",
      border: "1px solid var(--color-warm-golden)",
    },
    error: {
      backgroundColor: "var(--color-pencom-light-red)",
      color: "var(--color-dark-red)",
      border: "1px solid var(--color-pencom-red)",
    },
  };
  const bannerIcons = {
    info: "/assets/icons/info.svg",
    success: "/assets/icons/solid-check.svg",
    warning: "/assets/icons/alert-fill.svg",
    error: "/assets/icons/error.svg",
  };
  return (
    <div
      onClick={onClose}
      className={cn(
        "flex flex-row flex-wrap gap-3 sm:gap-x-4 rounded-lg justify-between items-start sm:items-center px-3 py-3 sm:px-4 sm:py-2",
        className
      )}
      style={bannerStyles[type]}
    >
      <div className="flex flex-row gap-3 sm:gap-x-4 min-w-0 flex-1">
        <img
          src={icon || bannerIcons[type]}
          alt="Banner Icon"
          loading="lazy"
          className="w-5 h-5 sm:w-6 sm:h-6 shrink-0 mt-0.5 sm:mt-0"
        />
        <div className="min-w-0 flex-1">
          {titleComponent || (
            <p className="font-clash-display text-md font-medium">{title}</p>
          )}
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

export const PencomGenericBanner = ({
  className,
  children,
  title,
}: {
  className?: string;
  children: React.ReactNode;
  title?: string;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-start justify-center gap-x-2 rounded-lg px-4 py-2 border border-stroke",
        className
      )}
    >
      {title && (
        <div className="flex flex-row items-center justify-center gap-x-2">
          <img
            src="/assets/icons/info-outline.svg"
            alt="Icon"
            className="w-4 h-4 self-start shrink-0"
            loading="lazy"
          />
          {title && (
            <p className="font-clash-display text-medium-dark-grey text-sm font-medium">
              {title}
            </p>
          )}
        </div>
      )}
      {children && (
        <div className="flex flex-row items-start justify-center gap-x-2">
          {!title && (
            <img
              src="/assets/icons/info-outline.svg"
              alt="Icon"
              className="w-4 h-4 self-start shrink-0"
              loading="lazy"
            />
          )}
          {children}
        </div>
      )}
    </div>
  );
};
